import { Link } from "react-router-dom";

function CTA() {
    return (
        <section className="cta">
            <div className="cta-container">
                <div className="cta-content">
                    <h2 className="cta-title">
                        E momentul sa incepi.
                    </h2>

                    <p className="cta-subtitle">
                        Fa primul pas catre o versiune mai puternica, mai disciplinata si mai increzatoare a ta.
                    </p>

                    <div className="cta-buttons">
                        <Link to="/contact" className="cta-btn primary">
                            Programeaza-te
                        </Link>

                        <Link to="/abonamente" className="cta-btn secondary">
                            Vezi abonamentele
                        </Link>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default CTA;